import React from 'react'
import { Avatar, Flex } from '@ui'
import { IFullEmployee } from '@api/types'
import { Classes } from '@blueprintjs/core'

interface EmployeeDragPreviewProps {
  employee?: IFullEmployee
}

export default function EmployeeDragPreview({ employee }: EmployeeDragPreviewProps) {
  if (!employee) return null

  return (
    <Flex
      className={Classes.POPOVER}
      align="center"
      style={{
        overflow: 'hidden',
        borderRadius: 20,
        backgroundColor: 'var(--primary-color)',
        padding: '4px 10px 4px 4px',
        fontSize: 16,
        pointerEvents: 'none',
        color: 'white',
      }}
    >
      <Avatar
        style={{ backgroundColor: 'white', color: 'black' }}
        size={Avatar.Size.XS}
        name={employee.name}
        assets={employee.assets}
      />
      <div style={{ marginLeft: 10 }}>{employee.name}</div>
    </Flex>
  )
}
